import {
    PlusIcon,
    SyncIcon,
    TrashIcon
} from "@primer/octicons-react";
import { Box, Checkbox } from '@primer/react';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Transition } from 'semantic-ui-react';
import { AnimationConfirm } from "../../../components/confirm";
import Button from "../../../components/ui/button";
import DataTable from "../../../components/ui/data-table";
import Text from "../../../components/ui/text";
import { PageBaseStatus } from "../../../models/pageBaseStatus";
import { sf_hinhthucmiengiam_group } from "../../../models/response/hinh-thuc-mien-giam/sf_hinhthucmiengiam_group";
import { changeHinhThucMienGiamGroupSelectionIds, closeHinhThucMienGiamGroupDetailModal, deleteHinhThucMienGiamGroupStart, loadHinhThucMienGiamGroupStart, saveHinhThucMienGiamGroupStart, showHinhThucMienGiamGroupDeleteConfirm, showHinhThucMienGiamGroupDetailModal } from "../../../state/actions/hinhThucMienGiamGroupActions";
import { RootState } from "../../../state/reducers";
import NhomMienGiamEditModal from "./NhomMienGiamEditModal";

const HinhThucMienGiamGroupPage = () => {
    const [danhSachNhomMienGiamSelectedIds, setDanhSachNhomMienGiamSelectedIds] = useState<number[]>([]);
    const { dm_coso_id } = useSelector((state: RootState) => state.common)
    const dispatch = useDispatch();
    const grid = useRef<any>();
    const state = useSelector((state: RootState) => state.hinhThucMienGiamGroup)
    const {
        status,
        sf_hinhthucmiengiam_groups,
        sf_hinhthucmiengiam_group_editing,
        is_show_detail_modal,
        is_show_delete_confirm
    } = state;
    const dataSource = useMemo(() => {
        return sf_hinhthucmiengiam_groups.filter(x => x.dm_coso_id === dm_coso_id)
    }, [sf_hinhthucmiengiam_groups, dm_coso_id])

    useEffect(() => {
        dispatch(loadHinhThucMienGiamGroupStart())
    }, [])


    const handleRefresh = useCallback(() => {
        dispatch(loadHinhThucMienGiamGroupStart());
        onSelectionChanged([])
        setDanhSachNhomMienGiamSelectedIds([])
    }, [])

    const handleCloseDeleteConfirm = useCallback(() => {
        dispatch(showHinhThucMienGiamGroupDeleteConfirm(false))
    }, [])

    const handleShowDeleteConfirm = useCallback(() => {
        dispatch(showHinhThucMienGiamGroupDeleteConfirm(true))
    }, [])

    const handleBtnInsertClick = useCallback(() => {
        dispatch(showHinhThucMienGiamGroupDetailModal());
    }, []);

    const handleBtnEditClicked = (data: sf_hinhthucmiengiam_group) => {
        dispatch(showHinhThucMienGiamGroupDetailModal(data));
    }
    const handleExport = useCallback(() => {
        if (grid && grid.current && grid.current.instance) {
            grid.current.instance.exportToExcel();
        }
    }, [grid])
    const onSelectionChanged = ({ selectedRowKeys }: any) => {
        dispatch(changeHinhThucMienGiamGroupSelectionIds(selectedRowKeys))

    };
    const handleConfirmDelete = useCallback(() => {
        dispatch(deleteHinhThucMienGiamGroupStart(danhSachNhomMienGiamSelectedIds))
        setDanhSachNhomMienGiamSelectedIds([])
    }, [danhSachNhomMienGiamSelectedIds]);

    const handleCloseDetailModal = useCallback(() => {
        dispatch(closeHinhThucMienGiamGroupDetailModal())
    }, [])
    const handleSubmitDetailModal = useCallback((data: sf_hinhthucmiengiam_group) => {
        dispatch(saveHinhThucMienGiamGroupStart(data))
        dispatch(closeHinhThucMienGiamGroupDetailModal())
    }, [])
    return (
        <React.Fragment>
            <Box sx={{ p: 2, pt: 0 }}>
                <Transition animation="scale"
                    visible={true}
                    duration={100}
                    transitionOnMount={true}>
                    <Box>
                        <Box sx={{ m: 1 }}>
                            <DataTable
                                height="calc(100vh - 200px)"
                                titleComponent={<Text text="Danh sách nhóm miễn giảm" sx={{ fontSize: 16, fontWeight: 600 }} />}
                                data={dataSource}
                                
                                selection={{
                                    mode: "multiple",
                                    keyExpr: "id",
                                    selectedRowKeys: danhSachNhomMienGiamSelectedIds,
                                    onSelectionChanged(keys) {
                                        setDanhSachNhomMienGiamSelectedIds(keys)
                                    },
                                }}
                                exportEnable
                                filterRow={{
                                    enable: true
                                }}
                                actionComponent={
                                    <Box sx={{
                                        display: "flex"
                                    }}>
                                        <Button sx={{ ml: 2 }} variant="default" size="small" leadingVisual={SyncIcon} onClick={handleRefresh}>Làm mới</Button>
                                        <Button sx={{ ml: 2 }} variant="primary" size="small" leadingVisual={PlusIcon} onClick={handleBtnInsertClick}>Thêm mới</Button>
                                        {/* <Button sx={{ ml: 2 }} leadingVisual={DownloadIcon} variant="default" size="medium" onClick={handleExport}>Xuất excel</Button> */}
                                        {danhSachNhomMienGiamSelectedIds && danhSachNhomMienGiamSelectedIds.length > 0 &&
                                            <Button sx={{ ml: 2 }} leadingVisual={TrashIcon} variant="danger" size="small" onClick={handleShowDeleteConfirm}>Xóa {danhSachNhomMienGiamSelectedIds.length} nhóm miễn giảm</Button>
                                        }
                                    </Box>
                                }
                                columns={[
                                    {
                                        caption: "Sửa",
                                        id: "edit",
                                        width: "50px",
                                        align: "center",
                                        isAllowFocus: false,
                                        cellRender: useCallback((data: any) => (
                                            <a id={`btnEdit${data.id}`} style={{ cursor: "pointer", color: "#3c22ff" }}>
                                                <i onClick={() => handleBtnEditClicked(data)} className="cmd-edit-icon fas fa-edit"></i>
                                            </a>
                                        ), [handleBtnEditClicked]),
                                    },
                                    {
                                        caption: "Áp dụng",
                                        id: "is_active",
                                        dataField: "is_active",
                                        isAllowFocus: false,
                                        cellRender: (data: any) => (
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Checkbox
                                                    checked={data.is_active === true}
                                                    aria-label="Kích hoạt"
                                                />
                                            </div>
                                        ),
                                    },
                                    {
                                        caption: "Mã nhóm miễn giảm",
                                        id: "ma_nhom_mien_giam",
                                        dataField: "ma_nhom_mien_giam",
                                        isAllowFocus: false,
                                    },
                                    {
                                        caption: "Tên nhóm miễn giảm",
                                        id: "ten_nhom_mien_giam",
                                        dataField: "ten_nhom_mien_giam",
                                        isAllowFocus: false,
                                    },
                                    {
                                        caption: "Thứ tự",
                                        id: "thu_tu",
                                        dataField: "thu_tu",
                                        isAllowFocus: false,
                                    },
                                ]}
                                paging={{
                                    enable: true,
                                    pageSizeItems: [50, 100, 200, 500]
                                }}
                            />
                            {is_show_detail_modal && <NhomMienGiamEditModal
                                title={sf_hinhthucmiengiam_group_editing ? `Cập nhật` : "Thêm mới"}
                                sf_hinhthucmiengiam_group={sf_hinhthucmiengiam_group_editing}
                                onClose={handleCloseDetailModal}
                                onSubmit={handleSubmitDetailModal}
                                is_saving={status === PageBaseStatus.is_saving}
                                animationOf={sf_hinhthucmiengiam_group_editing ? `#btnEdit${sf_hinhthucmiengiam_group_editing.id}` : "#btnInsert"}
                                sf_hinhthucmiengiam_groups={dataSource}
                            />
                            }
                        </Box>

                    </Box>
                </Transition>
                {is_show_delete_confirm &&
                    <AnimationConfirm
                        onClose={handleCloseDeleteConfirm}
                        onConfirmed={handleConfirmDelete}
                        text={`Bạn có chắc chắn muốn xóa ${danhSachNhomMienGiamSelectedIds.length} dòng đã chọn ?`}
                        is_saving={status === PageBaseStatus.is_deleting}
                        text_close_button="Không xóa"
                        text_confirm_button="Xóa"
                        type='danger'
                        animationOf='#btnDelete'

                    />
                }
            </Box>
        </React.Fragment>
    );
}
export default HinhThucMienGiamGroupPage;